import React from 'react'
import { useSelector } from 'react-redux'
import DashboardCompanyTeamRow from './table-row'

import './style.scss'

const Index = ({searchQuery}) => {

    const allMembers = useSelector(state => state.company.team) 
    const loading = useSelector(state => state.company.fetchFullTeam.loading)
    const detailsLoading = useSelector(state => state.company.fetchDetails.loading)

    /*
    const dispatch = useDispatch()

    const [firstLoad, setFirstLoad] = useState(true)

    const user = useSelector(state => state && state.user && state.user.details && state.user.details.id)
    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const libraryFiles = useSelector(state => state && state.library && state.library.content)
    const loading = useSelector(state => state.library.contentLoading)

    const [selectDeleted, setSelectDeleted] = useState([])

    useEffect(() => {

        if(selectedCompany){
            dispatch(retrieveLibraryFiles({company: selectedCompany}))
            dispatch(resetLibraryFiles())
        }
    }, [selectedCompany]);

    const addDeletionArray = (e) => {
        const value = e.target.attributes.getNamedItem("fileId").value;
        if(e.target.checked){
            if(!selectDeleted.includes(value)){
                setSelectDeleted(prevState => [...prevState, value])
            }
        } else {
            if(selectDeleted.includes(value)){
                setSelectDeleted(selectDeleted => selectDeleted.filter(id => id !== value))
            }
        }
    }*/

    if(!loading && !detailsLoading)

    return(
        <section className="full-team-section">
            <div className="inner-full-team-container">
                <table className="full-team-table">
                    <thead>
                    <tr>
                        <th>Fullt navn</th>
                        <th>Dato lagt til</th>
						<th>Rolle</th>
                        <th>Handling</th>
                    </tr>
                    </thead>
                    <tbody>
                    {allMembers.map((member, index, arr) => {
                        if(!searchQuery){
                            return(<DashboardCompanyTeamRow member={member} index={index} arr={arr}/>)
                        } else {
                            if(member.name.toLowerCase().includes(searchQuery.toLowerCase())){
                                return(<DashboardCompanyTeamRow member={member} index={index} arr={arr}/>)
                            }
                        }
                    })}
                    </tbody>
                </table>
            </div>
        </section>
    )

    return null
}

export default Index



